import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

// Vertical three-dot overflow glyph. Vector from Figma V6 Top Navigation
// (node 9830:27322, "3 dots"): three 3px circles in a 3x16 column. The
// square width/height with a 3:16 viewBox letterboxes horizontally, so the
// column renders centered at the exact design proportions.
export const MoreVerticalIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 3 16"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M3 1.6C3 2.48366 2.32843 3.2 1.5 3.2C0.671573 3.2 0 2.48366 0 1.6C0 0.716344 0.671573 0 1.5 0C2.32843 0 3 0.716344 3 1.6Z"
      fill={color}
    />
    <Path
      d="M3 8C3 8.88366 2.32843 9.6 1.5 9.6C0.671573 9.6 0 8.88366 0 8C0 7.11634 0.671573 6.4 1.5 6.4C2.32843 6.4 3 7.11634 3 8Z"
      fill={color}
    />
    <Path
      d="M3 14.4C3 15.2837 2.32843 16 1.5 16C0.671573 16 0 15.2837 0 14.4C0 13.5163 0.671573 12.8 1.5 12.8C2.32843 12.8 3 13.5163 3 14.4Z"
      fill={color}
    />
  </Svg>
);

MoreVerticalIcon.displayName = 'MoreVerticalIcon';
